import {ShortcodeManger} from './shortcodeManger';
import {SlButton, SlDialog, SlTabGroup} from '../../../../vendor/plugins/clxFrontendCms/public/js/shoelace/shoelace';
import {ReloadManager} from '../cmsmodule/reloadManager';
import {notNull} from '../../../../vendor/plugins/clxMobileNetPortable/assets/responsive/js/common/assert';
import {CookieManager} from '../common/cookieManager';

export class BeratungsManager {
    private readonly SAVE_MICRO_ACTION = '/merkliste/save_microconversion';

    private readonly MICRO_CONVERSION_TYPE = 'BERATUNG';

    private readonly beratungTabGroup: SlTabGroup | null;
    private readonly reloadManager: ReloadManager;

    private readonly cookieRegistrationLayerDismissed = 'REGISTER_LAYER_DISMISSED';
    private readonly cookieManager: CookieManager;

    constructor(viewRoot: HTMLElement) {
        this.cookieManager = new CookieManager();
        this.beratungTabGroup = viewRoot.querySelector('.beratung-tab-group');

        this.reloadManager = new ReloadManager();
        this.initEvents(viewRoot);
    }

    private initEvents(viewRoot: HTMLElement): void {
        this.initTabClickEvents(viewRoot);

        const kombiRadios = viewRoot.querySelectorAll<HTMLInputElement>('.provider.kombiprovider input');
        if (kombiRadios.length !== 0) {
            this.initKombiProviderClickEvents(kombiRadios);
        }
        const rufnummerRadios = viewRoot.querySelectorAll<HTMLInputElement>('.provider.rufnummer-provider input');
        if (rufnummerRadios.length !== 0) {
            this.initKombiProviderClickEvents(rufnummerRadios);
        }

        this.initButtonNextStep(viewRoot);
        this.initButtonNextStepWithClearForm(viewRoot);
        this.initButtonClearAllFilter(viewRoot);

        this.initLinkChangeFilterShortcode(viewRoot);
        this.initLinkChangeFilterTab(viewRoot);
        this.initSaveSearchButton(viewRoot);
    }

    private initTabClickEvents(viewRoot: HTMLElement): void {
        // wenn man auf einen tab klickt, soll da modul abgeschickt werden, damit z.b. nur die Provider von ausgeaehlen Netz angezeigt werden
        const beratungTabs = viewRoot.querySelectorAll<HTMLElement>('.beratung-tab-group sl-tab');
        if (beratungTabs.length === 0) {
            return;
        }

        beratungTabs.forEach((consultingTab) => {
            consultingTab.addEventListener('click', (event: Event) => {
                // aktuellen step setzen, damit man wenn man auf die tabs klickt und dann weiter klickt auch im naechsten step landet

                const clickTarget = event.target as HTMLElement;
                const form = clickTarget.closest('.form-standard') as HTMLFormElement;
                const currentStep = form?.querySelector<HTMLInputElement>('#currentStep');

                // wenn beratung abgeschlossen (closed) dann gibt es keinen currentStep
                if (currentStep) {
                    const stepValue = parseInt(clickTarget.dataset.step || '0', 10);
                    currentStep.value = stepValue.toString();
                    this.reloadManager.reloadModule(form, true, true);
                } else {
                    // im shortcode muessen trotzdem dem hoehe setzen wenn man dann ein tab waehlt
                    setTimeout(() => {
                        new ShortcodeManger();
                    }, 1000);
                }
            });
        });
    }

    // In der Mobilfunktarifliste gibt es einen KombiProvider oder auf den RufnummerProvider klickt, es darf immer nur einer gewaehlt werden
    // braucht das damit man den provider (radio) auch wieder abwaehlen kann
    private initKombiProviderClickEvents(kombiRadios: NodeListOf<HTMLInputElement>): void {
        kombiRadios.forEach((kombiRadio) => {
            kombiRadio.addEventListener('click', () => {
                // ueberpruefen, ob das aktuell geklickte Radio bereits aktiv ausgewaehlt ist
                const isAlreadyChecked = kombiRadio.hasAttribute('checked') && kombiRadio.checked;

                // Entferne das `checked`-Attribut und deaktiviere alle Radio-Buttons in der Gruppe
                kombiRadios.forEach((radio) => {
                    radio.removeAttribute('checked');
                    radio.checked = false;
                });

                // Falls der geklickte bereits aktiv ausgewaehlt war, keine weitere Aktion nach dem abwaehlen
                if (isAlreadyChecked) {
                    return;
                }

                // Setze das `checked`-Attribut und aktiviere den geklickten Radio-Button
                kombiRadio.setAttribute('checked', 'checked');
                kombiRadio.checked = true;
            });
        });
    }

    private initButtonNextStep(viewRoot: HTMLElement): void {
        if (!this.beratungTabGroup) {
            return;
        }

        const beratungTabGroup: SlTabGroup = this.beratungTabGroup;

        const goToNextTabs = viewRoot.querySelectorAll<SlButton>('.consult-availability .go-to-next-tab');
        if (goToNextTabs.length === 0) {
            return;
        }

        goToNextTabs.forEach((button) => {
            button.addEventListener('click', (event: Event) => {
                event.preventDefault();

                const activeTab = beratungTabGroup.querySelector('sl-tab[active]') as HTMLElement;
                const nextTab = activeTab?.nextElementSibling as HTMLElement;
                if (nextTab) {
                    beratungTabGroup.show(`${nextTab.getAttribute('panel')}`);
                }
                const form = button.closest('form') as HTMLFormElement;
                const currentStep = form?.querySelector<HTMLInputElement>('#currentStep');

                // Wenn `currentStep` existiert, den Wert inkrementieren
                if (currentStep) {
                    currentStep.value = (parseInt(currentStep.value) + 1).toString();
                }

                setTimeout(() => {
                    new ShortcodeManger();
                }, 1000);
            });
        });
    }

    // In der Mobilfunktarifliste gibt es einen Button "weiter ohne Angabe" wo die bereits gewaehlen felder deaktiviert werden sollen
    private initButtonNextStepWithClearForm(viewRoot: HTMLElement): void {
        const clearFilterButtons = viewRoot.querySelectorAll<SlButton>('.form-beratung-list-filter .bt-clear-filter-tab');
        if (clearFilterButtons.length === 0) {
            return;
        }

        clearFilterButtons.forEach((button) => {
            button.addEventListener('click', (event: Event) => {
                event.preventDefault();

                const tabPanel = button.closest('sl-tab-panel');
                if (tabPanel) {
                    // Alle Eingabefelder innerhalb des Tab-Panels zuruecksetzen
                    const inputs = tabPanel.querySelectorAll<HTMLInputElement>('input');
                    inputs.forEach((input) => {
                        input.value = 'clear';
                    });
                }
                const form = button.closest('form') as HTMLFormElement;
                if (form) {
                    this.reloadManager.reloadModule(form);
                }
            });
        });
    }

    private initButtonClearAllFilter(viewRoot: HTMLElement): void {
        const clearAllFilterButtons = viewRoot.querySelectorAll<SlButton>('.clearBeratungsFilter');
        if (clearAllFilterButtons.length === 0) {
            return;
        }

        clearAllFilterButtons.forEach((button) => {
            button.addEventListener('click', (event: Event) => {
                event.preventDefault();

                let form = button.closest('form') as HTMLFormElement;

                // Falls kein umschliessendes Formular gefunden wurde, das Formular innerhalb des CMS-Moduls suchen
                // in dem fall sind wir in der liste - nulltreffer bereich
                if (!form) {
                    const moduleRoot = button.closest('.cms-module-root');
                    form = moduleRoot?.querySelector('form') as HTMLFormElement;
                    if (!form) {
                        return;
                    }
                }

                // `clearBeratungsFilter`-Feld auf `1` setzen, um Filter zu leeren
                const clearFilterField = form.querySelector<HTMLInputElement>('[name="clearBeratungsFilter"]');
                if (clearFilterField) {
                    clearFilterField.value = '1';
                }
                this.reloadManager.reloadModule(form, true, true);
            });
        });
    }

    // im Shortcode gibt es einen Button "Suche aendern" der die Filter wieder auf den Anfangszustand setzt
    private initLinkChangeFilterShortcode(viewRoot: HTMLElement): void {
        const changeFilterButtons = viewRoot.querySelectorAll<HTMLAnchorElement>('.shortcodeChangeFilter');
        if (changeFilterButtons.length === 0) {
            return;
        }

        changeFilterButtons.forEach((button) => {
            button.addEventListener('click', (event: Event) => {
                event.preventDefault();

                this.toggleBeratungsFilter(viewRoot);
                this.deselectTabs(viewRoot);

                const firstTabName = this.getTabNameByNumber(viewRoot, 0);
                if (firstTabName) {
                    this.activateTab(firstTabName);
                }

                this.showBeratungsFilterBox(viewRoot);
            });
        });
    }

    private initLinkChangeFilterTab(viewRoot: HTMLElement): void {
        this.initChangeStepButton(viewRoot, '.form-beratung-list-filter .changeStep1', 0);
        this.initChangeStepButton(viewRoot, '.form-beratung-list-filter .changeStep2', 1);
        this.initChangeStepButton(viewRoot, '.form-beratung-list-filter .changeStep3', 2);
        this.initChangeStepButton(viewRoot, '.form-beratung-list-filter .changeStep4', 3);
    }

    private initChangeStepButton(viewRoot: HTMLElement, selector: string, tabNumber: number): void {
        const changeStepButtons = viewRoot.querySelectorAll<HTMLAnchorElement>(selector);
        if (changeStepButtons.length === 0) {
            return;
        }

        changeStepButtons.forEach((button) => {
            button.addEventListener('click', (event: Event) => {
                event.preventDefault();

                this.toggleBeratungsFilter(viewRoot);
                this.deselectTabs(viewRoot);

                const tabName = this.getTabNameByNumber(viewRoot, tabNumber);
                if (tabName) {
                    this.activateTab(tabName);
                }

                this.showBeratungsFilterBox(viewRoot);
            });
        });
    }

    private toggleBeratungsFilter(viewRoot: HTMLElement): void {
        const closed = viewRoot.querySelector('.beratung-list-filter .closed');
        if (closed) {
            closed.classList.remove('closed');
        }

        const inactiv = viewRoot.querySelector('.beratung-list-filter .inactiv');
        if (inactiv) {
            inactiv.classList.add('closed');
        }
    }

    private deselectTabs(viewRoot: HTMLElement) {
        const tabs = viewRoot.querySelectorAll('.beratung-list-filter sl-tab, .beratung-list-filter sl-tab-panel');
        if (tabs.length < 1) {
            return;
        }
        tabs.forEach((tab) => {
            tab.removeAttribute('active');
        });
    }

    private getTabNameByNumber(viewRoot: HTMLElement, tabNumber: number): string | null {
        // Alle `sl-tab`-Elemente sammeln
        const tabs = Array.from(viewRoot.querySelectorAll('sl-tab'));

        // ueberpruefen, ob die Tab-Nummer gueltig ist
        if (tabs.length > tabNumber) {
            const tab = tabs[tabNumber];
            return tab.getAttribute('panel');
        }

        return null;
    }

    private activateTab(tabName: string): void {
        if (!this.beratungTabGroup) {
            return;
        }

        const beratungTabGroup: SlTabGroup = this.beratungTabGroup;

        const tab = document.querySelector(`sl-tab[panel="${tabName}"]`);
        if (tab) {
            tab.setAttribute('active', '');
        }

        const tabContent = document.querySelector(`sl-tab-panel[name="${tabName}"]`);
        if (tabContent) {
            tabContent.setAttribute('active', '');
        }
        beratungTabGroup.show(tabName);
    }

    private showBeratungsFilterBox(viewRoot: HTMLElement) {
        const beratungOuterInfobox = viewRoot.querySelector('.outer-infobox');
        const beratungFilterArea = viewRoot.querySelector('.beratung-list-filter');
        if (beratungOuterInfobox && beratungFilterArea) {
            beratungOuterInfobox.remove();
            beratungFilterArea.classList.remove('closed');
        }

        setTimeout(() => {
            new ShortcodeManger();
        }, 1000);
    }

    private initSaveSearchButton(viewRoot: HTMLElement): void {
        const saveSearchButton: SlButton | null = viewRoot.querySelector('.safe-search-container sl-button');
        if (!saveSearchButton) {
            return;
        }

        const dialog = notNull(viewRoot.querySelector('sl-dialog.save-user-layer-dialog')) as SlDialog;

        saveSearchButton.addEventListener('click', () => {
            if (this.cookieManager.getCookie(this.cookieRegistrationLayerDismissed)) {
                return;
            }

            this.saveMircoconversion(notNull(saveSearchButton.dataset.art));

            dialog.show();
            this.cookieManager.setCookie(this.cookieRegistrationLayerDismissed, 'true');
        });
    }

    private saveMircoconversion(art: string): void {
        const formData = new FormData();
        formData.append('art', art);
        formData.append('typ', this.MICRO_CONVERSION_TYPE);

        fetch(this.SAVE_MICRO_ACTION, {
            method: 'POST',
            body: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            cache: 'default',
            credentials: 'same-origin',
        });
    }
}
